package fr.frux.core.common.prefs

/**
 * Platform-agnostic storage for small, non-sensitive app preferences
 * (onboarding flags, UI choices). Secrets belong in TokenStorage.
 *
 * Platform implementations:
 * - Android: SharedPreferences
 * - iOS: NSUserDefaults
 * - Desktop: properties file in ~/.frux
 * - Web: localStorage, repli en mémoire si le navigateur le refuse (#610)
 */
interface AppPreferences {
    suspend fun getBoolean(
        key: String,
        default: Boolean = false,
    ): Boolean

    suspend fun putBoolean(
        key: String,
        value: Boolean,
    )

    suspend fun getString(
        key: String,
        default: String? = null,
    ): String?

    suspend fun putString(
        key: String,
        value: String,
    )

    /** Drops the entry entirely. Used to honour logout purges, where a stale default would leak. */
    suspend fun remove(key: String)
}

/**
 * Platform-specific factory for creating AppPreferences.
 */
expect fun createAppPreferences(): AppPreferences
